module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/ponderosa_bw-p-1600-93656be4ac0f24cc04bce5b7eb3c9f67.jpg";